import { createApp } from 'vue'
import BootstrapVue3 from 'bootstrap-vue-3'
import Amplify from 'aws-amplify'
import {
  PulsCardHeader,
  PulsFormRadio,
  PulsFormInput,
  PulsFormCheckbox
} from '@puls-solutions/puls-ui-components-vue3'
import DevOps from '@puls-solutions/puls-devops-utils'
import App from './App.vue'
import config from './config'
import router from './router'
import VueHelper from './helpers/VueHelper'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@puls-solutions/puls-good-html/theme/dist/assets/css/style.bundle.css'
import i18n from './i18n'
import '@puls-solutions/puls-ui-components-vue3/dist/puls-ui-components-vue3.css'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

const c = DevOps.WebApp.configToUse({ config })

const configObject = {
  API: {
    endpoints: [
      {
        name: 'ReporterAPI',
        endpoint: c.reporterApiUrl,
        region: 'eu-west-1',
        custom_header: async () => ({
          'x-api-key': c.apiKey
        })
      },
      {
        name: 'PublicAPI',
        endpoint: c.publicApiUrl,
        region: 'eu-west-1',
        custom_header: async () => ({
          'x-api-key': c.apiKey
        })
      }
    ]
  }
}

Amplify.configure(configObject)

createApp(App)
  .component('puls-card-header', PulsCardHeader)
  .component('puls-form-radio', PulsFormRadio)
  .component('puls-form-input', PulsFormInput)
  .component('puls-form-checkbox', PulsFormCheckbox)
  .use(i18n)
  .use(router)
  .use(BootstrapVue3)
  .provide('$ft', VueHelper.ft)
  .provide('$featureToggles', VueHelper.featureToggles)
  .mount('#app')
